import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useRPCIdByPletteCardTemplate = (paletteId: string | undefined, cardTemplateId: string | undefined) : string => {
  const rpcDb = useSelector((state: RootState) => state.relationPaletteCardTemplateDb);
  const id = Object.keys(rpcDb.relationPaletteCardTemplates).filter(id => {
    return rpcDb.relationPaletteCardTemplates[id].cardTemplateId === cardTemplateId && rpcDb.relationPaletteCardTemplates[id].paletteId === paletteId;
  })[0];

  return id;
}

export default useRPCIdByPletteCardTemplate;
